<div
  *ngFor="let row of shapedData; let i = index"
  class="row"
  [ngClass]="{ 'header-row': row.isHeader, 'sub-header': row.isHeader && i != 0 }"
>
  <span *ngFor="let col of row.content; let j = index" class="column" [ngClass]="{ first: j === 0, other: j !== 0 }">{{
    col
  }}</span>
</div>
